import { ToastMessage } from '@cokitchen/cokitchen-components';
import LiveTripCards from 'components/live-trip-cards';
import { OrderType } from 'models/order.model';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'utils/api';

const ScheduledOrders = () => {
  const [orders, setOrders] = useState([] as OrderType[]);
  const [loading, setLoading] = useState(false);

  const loadOrders = async () => {
    setLoading(true);
    try {
      const res = await apiService.get('scheduled/order', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      const scheduled: any = res?.data?.data ?? [];
      setOrders(
        scheduled
          .map((o: any) => ({
            ...o,
            scheduled: true,
            isSchedulePage: true
          }))
          .sort(
            (a: any, b: any) =>
              new Date(a.scheduled_delivery_datetime).getTime() -
              new Date(b.scheduled_delivery_datetime).getTime()
          )
      );
    } catch {
      toast(
        <ToastMessage type='error' message='Problem encountered while loading scheduled orders' />
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadOrders();
  }, []);
  return (
    <div>
      {loading ? (
        <p>Loading</p>
      ) : orders.length === 0 && !loading ? (
        <p>No scheduled orders </p>
      ) : (
        <LiveTripCards orders={orders} />
      )}
    </div>
  );
};
export default ScheduledOrders;
